import { CreateHealthInsuranceByPatient } from 'domain/usecases/patient/create-health-insuranceby-patient'
import { PatientNewRepository } from 'repository/interfaces/patient-new-repository'

export class RemoteCreateHealthInsuranceByPatient
  implements CreateHealthInsuranceByPatient
{
  constructor(private readonly patientNewRepository: PatientNewRepository) {}

  create(
    params: CreateHealthInsuranceByPatient.Params
  ): Promise<CreateHealthInsuranceByPatient.Model> {
    return this.patientNewRepository.createHealthInsuranceByPatient(params)
  }
}
